module.exports = __webpack_public_path__ + "static/media/IconPasswordOff.3eb10e8b.svg";